import { createActions } from 'reflux';

const onboardingActions = createActions([
  'register'
]);

export default onboardingActions;
